import React from "react";
import { Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

import { PollLefTimeWrapper } from "../styled";
import { useTranslation } from "react-i18next";

interface IPollTimer {
    leftTime: number;
    setExpiredDate: () => void;
    votingTimeLimit: number;
}

const PollTimer: React.FC<IPollTimer> = ({
    leftTime,
    setExpiredDate,
    votingTimeLimit,
}) => {
    const { t } = useTranslation();
    const [remainingMs, setRemainingMs] = React.useState(
        Math.max(0, leftTime || 0)
    );
    const hasFiredExpirationRef = React.useRef(false);

    React.useEffect(() => {
        setRemainingMs(Math.max(0, leftTime || 0));
        hasFiredExpirationRef.current = false;
    }, [leftTime]);

    const shouldRunTimer = votingTimeLimit !== 0 && remainingMs > 0;

    React.useEffect(() => {
        if (!shouldRunTimer) {
            return;
        }

        const timeoutId = window.setTimeout(() => {
            setRemainingMs((previousMs) =>
                previousMs <= 1000 ? 0 : previousMs - 1000
            );
        }, 1000);

        return () => {
            window.clearTimeout(timeoutId);
        };
    }, [remainingMs, shouldRunTimer]);

    React.useEffect(() => {
        if (
            votingTimeLimit !== 0 &&
            remainingMs <= 0 &&
            !hasFiredExpirationRef.current
        ) {
            hasFiredExpirationRef.current = true;
            setExpiredDate();
        }
    }, [remainingMs, setExpiredDate, votingTimeLimit]);

    const totalSeconds = Math.floor(remainingMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const formatUnit = (value: number) => (value < 10 ? `0${value}` : value);

    return (
        <PollLefTimeWrapper title="Closes in">
            <Typography
                variant="body2"
                color={remainingMs <= 0 ? "error" : "textSecondary"}
                component="p"
                style={{
                    display: "flex",
                    alignItems: "center",
                }}
            >
                {votingTimeLimit !== 0 && remainingMs > 0 ? (
                    <>
                        <AccessTimeIcon />
                        {`${formatUnit(hours)}h ${formatUnit(
                            minutes
                        )}m ${formatUnit(seconds)}s`}
                    </>
                ) : votingTimeLimit !== 0 && remainingMs <= 0 ? (
                    <>
                        <AccessTimeIcon /> {t("poll_item.closed")}
                    </>
                ) : null}
            </Typography>
        </PollLefTimeWrapper>
    );
};

export default PollTimer;
